import { Button } from '@kanda-libs/ks-design-library';
import { Copyright } from 'components';
import { DEFAULT_NEXT_BUTTON_PROPS } from '../constants';

interface FooterProps {
  isDesktop?: boolean;
  showNextButton?: boolean;
  nextButtonProps?: {
    disabled?: boolean;
  };
  isSubmitting?: boolean;
}

const Footer = ({
  isDesktop,
  showNextButton,
  nextButtonProps,
  isSubmitting,
}: FooterProps) => {
  const nextButton = (
    <Button.Text
      {...DEFAULT_NEXT_BUTTON_PROPS}
      {...nextButtonProps}
      disabled={!!nextButtonProps?.disabled || !!isSubmitting}
    />
  );

  if (isDesktop) {
    return <div className="mt-10">{showNextButton && nextButton}</div>;
  }

  return (
    <div className="flex flex-col">
      {showNextButton && nextButton}
      <Copyright />
    </div>
  );
};

Footer.defaultProps = {
  isDesktop: false,
  showNextButton: true,
  nextButtonProps: {},
  isSubmitting: false,
};

export default Footer;
